import { createFileRoute, Link } from "@tanstack/react-router";
import { InfoLayout } from "@/components/laneguide/InfoLayout";
import { ArrowRight } from "lucide-react";
import { SERVICE_LIST } from "@/lib/service";
import sparaImg from "@/assets/news/spara-pengar.jpg";
import kortImg from "@/assets/news/betalkort-utomlands.jpg";
import bilImg from "@/assets/news/bilkop.jpg";
import kalkylImg from "@/assets/news/lanekostnader.jpg";

const POSTS = [
  // Senaste nyheten först – nya artiklar läggs alltid överst i listan.
  { slug: "lendo-billan", title: "Lendo billån – så fungerar det och vad det kostar 2026", excerpt: "Hur Lendos billånejämförelse fungerar, vad räntan blir i kronor, kraven – och när handlarens finansiering är billigare." },
  { slug: "lana-pengar-utan-avslag", title: "Låna pengar utan avslag – så ökar du chansen 2026", excerpt: "Varför avslagen kommer, vilka långivare som har högst beviljandegrad – och sju steg som vänder ett nej till ett ja." },
  { slug: "lana-pengar-direkt", title: "Låna pengar direkt – så får du pengarna samma dag 2026", excerpt: "Vilka långivare betalar ut inom minuter, vad det kostar i kronor – och de billigare alternativen innan du signerar." },
  { slug: "lana-pengar-med-skuld-hos-kronofogden", title: "Låna pengar med skuld hos Kronofogden – vad som gäller 2026", excerpt: "Pågående mål eller reglerad skuld, vilka långivare som kan säga ja, kostnaden 2026 – och gratisalternativen som ofta är bättre." },
  { slug: "snabblan-utbetalning-direkt", title: "Snabblån utbetalning direkt – så snabbt får du pengarna 2026", excerpt: "Vilka långivare betalar ut på minuten, vad realtidsbetalning kräver – och vad ett snabblån faktiskt kostar i kronor." },
  { slug: "snabblan-5000-mikrolan", title: "Snabblån 5000 – mikrolån på 5 000 kr direkt 2026", excerpt: "Vad ett snabblån på 5 000 kr kostar, vilka som betalar ut direkt utan UC – och när ett mikrolån faktiskt är rimligt." },
  { slug: "lan-utan-uc-manga-forfragningar", title: "Lån utan UC med många förfrågningar – så gör du 2026", excerpt: "Hur förfrågningar påverkar din kreditvärdighet, vilka långivare som prövar utan UC – och stegen som vänder ett nej till ett ja." },
  { slug: "lan-15000-utan-uc", title: "Lån 15000 utan UC – så lånar du 15 000 kr utan UC 2026", excerpt: "Vilka långivare beviljar 15 000 kr utan UC, vad det kostar per månad, kraven – och när något annat är billigare." },
  { slug: "sms-lan-trots-kronofogden", title: "SMS lån trots Kronofogden – vad som faktiskt gäller 2026", excerpt: "Pågående mål eller avslutat ärende, vilka långivare som kan säga ja, kostnaden 2026 och gratisalternativen som ofta är bättre." },

  { slug: "sms-lan-som-beviljar-alla", title: "SMS lån som beviljar alla – finns det verkligen? Guide 2026", excerpt: "Ingen beviljar alla – men beviljandegraden skiljer sig kraftigt. Så ökar du chansen att bli godkänd." },
  { slug: "sms-lan-direkt-utbetalning-utan-uc", title: "SMS lån direkt utbetalning utan UC – så snabbt landar pengarna 2026", excerpt: "Creditsafe i stället för UC, utbetalning via Swish inom minuter, krav, kostnader och alternativ." },
  { slug: "billigaste-smslan", title: "Billigaste smslån 2026 – så hittar du lägst total kostnad", excerpt: "Effektiv ränta, dolda avgifter och räkneexempel som visar vilket smslån som faktiskt är billigast." },
  { slug: "smslan-swish", title: "Smslån Swish – så får du pengarna via Swish direkt 2026", excerpt: "Hur snabbt utbetalningen går, vilka banker som klarar realtid och vad ett snabblån kostar." },
  { slug: "nya-smslan-2026", title: "Nya smslån 2026 – nya långivare, nya regler och vad som faktiskt är bättre", excerpt: "Vilka nya aktörer som kommit, räntetak och kostnadstak 2026 – och hur du känner igen en seriös långivare." },
  { slug: "smslan-utan-inkomst", title: "Smslån utan inkomst – vad som faktiskt gäller 2026", excerpt: "Vilka inkomster som räknas, lån som arbetslös, kreditprövningen och alternativen som är gratis." },
  { slug: "snabblan-fran-1000-kr", title: "Snabblån Från 1000kr – så lånar du en liten summa direkt 2026", excerpt: "Vilka långivare beviljar 1 000 kr, vad det kostar och när något annat är billigare." },

  { slug: "akut-sms-lan-1000-kr-swish", title: "Akut SMS-Lån Från 1000 kr Via Swish – guide för 2026", excerpt: "Utbetalning via Swish, ansökan dygnet runt, utan UC och vad lagen säger om kostnaden." },
  { slug: "mikrolan-utan-uc-1000-kr", title: "Mikrolån Utan UC Från 1000 kr – jämförelse och guide 2026", excerpt: "Creditsafe eller Bisnode i stället för UC – så jämför du små lån rättvist 2026." },
  { slug: "smslan-helg", title: "SMS-lån helg – låna pengar direkt på lördag och söndag 2026", excerpt: "Så fungerar helgutbetalning, Swish, lån utan UC och vad ett snabblån får kosta enligt lag 2026." },
  { slug: "sms-lan-utan-uc", title: "SMS-lån utan UC – Så hittar du det säkraste alternativet 2026", excerpt: "Så hittar du ett säkert SMS-lån utan UC – räntetak, kostnadstak och fallgropar 2026." },

  {
    slug: "hur-man-kan-spara-pengar-pa-basta-satt",
    title: "Hur man kan spara pengar på bästa sätt",
    excerpt: "12 metoder som ger störst effekt på svensk privatekonomi 2026 – från dyra krediter till automatiskt sparande.",
    img: sparaImg,
  },
  {
    slug: "jamfor-kostnaderna-for-dina-bank--och-betalkort-fore-utlandsresan",
    title: "Jämför kostnaderna för dina bank- och betalkort före utlandsresan",
    excerpt: "Valutapåslag, uttagsavgifter och DCC kan kosta över 1 000 kr på en resa. Så undviker du dem.",
    img: kortImg,
  },
  {
    slug: "lana-pengar-till-bilkop",
    title: "Låna pengar till bilköp – billån eller privatlån?",
    excerpt: "Räkneexempel som visar vilket alternativ som blir billigast för ditt bilköp.",
    img: bilImg,
  },
  {
    slug: "laneguide-for-nyborjaren",
    title: "Låneguide för nybörjaren",
    excerpt: "Lånetyper, ränta, avgifter, kreditupplysning och ansökan – steg för steg på ren svenska.",
  },
  {
    slug: "rakna-ut-lanekostnader",
    title: "Räkna ut lånekostnader – formel och exempel",
    excerpt: "Formeln för månadskostnad och hur ränta, avgifter och löptid påverkar totalkostnaden.",
    img: kalkylImg,
  },
  {
    slug: "tips-att-tanka-pa-innan-man-lanar-pengar",
    title: "Tips att tänka på innan man lånar pengar",
    excerpt: "10 konkreta råd från vår redaktion – innan du signerar med BankID.",
  },
  {
    slug: "tips-nar-man-har-fatt-skulder-och-betalningsanmarkningar-hos-kronofogden",
    title: "Tips när man har fått skulder hos Kronofogden",
    excerpt: "Så fungerar betalningsanmärkningar och vilken hjälp som faktiskt finns att få.",
  },
  {
    slug: "vad-ar-ranta-och-hur-fungerar-det",
    title: "Vad är ränta och hur fungerar det?",
    excerpt: "Nominell och effektiv ränta, fast och rörligt – förklarat med exempel.",
  },
  { slug: "samla-lan-2026", title: "Så samlar du lån 2026 – komplett guide", excerpt: "Sänk månadskostnaden. Steg-för-steg för att konsolidera dyra krediter." },
  { slug: "vad-ar-privatlan", title: "Vad är ett privatlån? – Komplett guide", excerpt: "Kostnader, krav och hur du hittar det billigaste privatlånet." },
  { slug: "billan-utan-kontantinsats", title: "Billån utan kontantinsats – vad krävs?", excerpt: "Vad du behöver veta om 100 %-finansiering av bilköpet." },
  { slug: "snabblan-utan-uc", title: "Snabblån utan UC – när passar det?", excerpt: "Fördelar, nackdelar och när alternativa kreditupplysningsbolag är rätt val." },
  { slug: "rantan-manadskostnad", title: "Så påverkar räntan din månadskostnad", excerpt: "Räknemodeller och exempel för hur 1 % ränta påverkar din plånbok." },
  { slug: "betalningsanmarkning-lan", title: "Betalningsanmärkning – lån och lösningar", excerpt: "Så får du lån trots anmärkning – och hur du tar dig ur skuldfällan." },
  { slug: "sms-lan-guide", title: "SMS-lån – guide, kostnader och krav", excerpt: "Räntetak, krav och när ett SMS-lån är rimligt." },
];

export const Route = createFileRoute("/nyhet/")({
  head: () => ({
    meta: [
      { title: "Nyheter om lån, ränta och privatekonomi | Svensk Låneguide" },
      { name: "description", content: "Nyheter, guider och analyser om lån, räntor, sparande och privatekonomi – uppdaterat löpande av vår finansredaktion." },
      { property: "og:title", content: "Nyheter om lån, ränta och privatekonomi" },
      { property: "og:description", content: "Guider och analyser om lån, räntor, sparande och privatekonomi." },
      { property: "og:type", content: "website" },
    ],
  }),
  component: () => (
    <InfoLayout title="Nyheter">
      <p>Guider och analyser om lån, räntor, sparande och privatekonomi – uppdaterat löpande av vår finansredaktion.</p>

      <h2 className="mt-8 font-display text-2xl font-extrabold text-foreground">Guider och jämförelser</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        {SERVICE_LIST.map((p) => (
          <Link
            key={p.slug}
            to="/$hubSlug"
            params={{ hubSlug: p.slug }}
            className="group overflow-hidden rounded-md border border-border bg-card !no-underline transition-all hover:-translate-y-0.5 hover:border-primary/40"
          >
            <div className="p-5">
              <h3 className="font-display text-lg font-extrabold text-foreground">{p.title}</h3>
              <p className="mt-1.5 text-sm text-muted-foreground">{p.excerpt}</p>
              <div className="mt-3 inline-flex items-center gap-1 text-sm font-bold text-primary">
                Läs guiden <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </div>
            </div>
          </Link>
        ))}
      </div>

      <h2 className="mt-12 font-display text-2xl font-extrabold text-foreground">Senaste nyheterna</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        {POSTS.map((p) => (
          <Link
            key={p.slug}
            to="/nyhet/$slug"
            params={{ slug: p.slug }}
            className="group overflow-hidden rounded-md border border-border bg-card !no-underline transition-all hover:-translate-y-0.5 hover:border-primary/40"
          >
            {p.img && (
              <img src={p.img} alt={p.title} width={640} height={320} loading="lazy" className="h-40 w-full object-cover" />
            )}
            <div className="p-5">
              <h3 className="font-display text-lg font-extrabold text-foreground">{p.title}</h3>
              <p className="mt-1.5 text-sm text-muted-foreground">{p.excerpt}</p>
              <div className="mt-3 inline-flex items-center gap-1 text-sm font-bold text-primary">
                Läs mer <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </div>
            </div>
          </Link>
        ))}
      </div>

    </InfoLayout>
  ),
});

export { POSTS };
